import React from "react";

const FooterBottom = ({ RoutingController }) => {
  const padding = RoutingController === "Detail" ? "pb-36" : "pb-20";
  return (
    <div className="container">
      <div
        className={`${padding} flex flex-col items-center justify-center pt-4 text-themeBlack text-size-13 lg:py-8`}
      >
        <span>Tüm Hakları Saklıdır - 2021 © Villa Vagonu</span>
        <span className="underline">BöcekSoft</span>
      </div>
    </div>
  );
};

export default FooterBottom;
